import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme) => ({
  button: {},
  title: {
    textTransform: 'capitalize'
  },
  endIcon: {
    marginLeft: 0
  },
  startIcon: {
    marginLeft: 0
  },
  circularProgress: {
    margin: `0px ${theme.spacing(1)}`
  }
}))
